<ng-container *transloco="let t">
  <section class="celebrate">
    <section class="celebrate__content">
      <img src="https://cdn.pedix.app/celebrate.png" alt="" />
      <h3 class="h3">{{ t('success.title') }}</h3>
      <p class="big" [innerHtml]="t('success.subtitle')"></p>
      <pxw-button display="block" size="md" class="celebrate-button" (click)="finishRegistration()">
        {{ t('success.access') }}
      </pxw-button>
      <p>
        {{ t('success.aclaration') }}
      </p>
    </section>
    <pxw-alert type="success">
      {{ t('success.capacitation') }}
      <ng-template #alertDetails>
        <pxw-button
          type="success"
          href="https://calendly.com/pedix-soporte/primeros-pasos-con-pedix"
          target="_blank"
          [rounded]="true"
          size="md"
        >
          <pxw-icon icon="calendar" />
          {{ t('success.capacitationCta') }}
        </pxw-button>
      </ng-template>
    </pxw-alert>
  </section>
</ng-container>
